module.exports = __webpack_public_path__ + "img/plus.f4987a4e.svg";